import React, { useMemo, useCallback } from "react";
import { Flex, Select } from "../../../resourses/digitallabs/one-x-ui";

const DynamicSelect = ({
  field,
  fieldName,
  value,
  isMain,
  step,
  fieldRefs,
  normalizeItems,
  normalizeSelectValue,
  updateValue,
  renderLabelWithPrefix,
  renderField,
  resertSubtree,
  safeState,
  fieldIsRequired,
  validateSingleField,
  validateVisible,
  setErrors,
  setIsValid,
  onFormValidityChange,
  submitted,
  errors,
}) => {
  const items = normalizeItems(field.valid_answers);
  const current = value ?? field.default_answer ?? "";

  const visibleSubQuestions = useMemo(() => {
    if (!field.sub_questions) return [];

    return field.sub_questions.filter((sub) => {
      /*
          answer_selected meaning:
    
          null  -> always show
          value -> show only when selected chip matches
        */

      if (sub.answer_selected === null || sub.answer_selected === undefined || sub.answer_selected === "") {
        return true;
      }

      return sub.answer_selected === value;
    });
  }, [field.sub_questions, value]);

  return (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      <Select
        items={items}
        value={normalizeSelectValue(current)}
        closeOnSelect
        label={{
          label: renderLabelWithPrefix(isMain, field.question, step),
          optional: !fieldIsRequired(field),
        }}
        valuePlaceholder="Select"
        onValueChange={(details) => {
          const selectedValue = details.value?.[0] ?? "";
          updateValue(fieldName, selectedValue);
        }}
        onBlur={() => {
          const single = validateSingleField(field);
          setErrors((prev) => ({ ...prev, ...single }));

          const validation = validateVisible();
          const valid = Object.keys(validation).length === 0;

          setIsValid(valid);
          if (typeof onFormValidityChange === "function") {
            onFormValidityChange(valid);
          }
        }}
        size="md"
        helperText={submitted && errors[fieldName] ? { message: errors[fieldName], status: "error" } : undefined}
      />

      {visibleSubQuestions.map((sub, i) => (
        <Flex
          key={sub.name ?? `${fieldName}-sub-${i}`}
          direction="column"
          style={{
            marginTop: "12px",
            marginLeft: isMain ? "12px" : "0px",
          }}
        >
          {renderField(sub)}
        </Flex>
      ))}
    </Flex>
  );
};

export default DynamicSelect;
